module.exports = __webpack_public_path__ + "media/images/favicon/android-icon-36x36-139c221ab52f378dce6e7aa371f23456.png";